<div
  class="d-flex flex-column gap-4"
  [formGroup]="rejectOfferForm"
  [ngClass]="{ 'was-validated': isRejectFormSubmitted }"
>
  <span [innerHTML]="'inquiry.rejectOfferConfirmation' | translate: { fullName }"></span>
  <base-dropdown
    [items]="rejectionCauseList"
    formControlName="decliningCategory"
    [translateItems]="true"
    [searchable]="false"
    [requiredLabel]="true"
    bindOptionLabel="label"
    placeholder="inquiry.rejectReasonPlaceholder"
    baseFieldValidationArgs="rejectReasonRequired"
  ></base-dropdown>
  <base-textarea
    formControlName="decliningNote"
    placeholder="inquiry.rejectMessagePlaceholder"
    [isInvalid]="!!rejectOfferForm.controls.decliningNote.errors"
    [errorMessage]="rejectOfferForm.controls.decliningNote.errors | baseFieldValidation"
  ></base-textarea>

  <div class="modal-footer pb-3 px-0">
    <base-button
      class="btn-confirm"
      color="secondary"
      label="action.cancel"
      [size]="buttonSize.md"
      (btnClick)="closeModal()"
    ></base-button>
    <base-button
      class="btn-confirm"
      color="primary"
      label="action.okRefuse"
      [size]="buttonSize.md"
      (btnClick)="rejectOffer()"
    ></base-button>
  </div>
</div>
